import React from 'react';
import PropTypes from 'prop-types';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { wrapper } from '@store/store';

import PreRegister from '@routes/PreRegister';

import request from '@utils/request';
import { authenticatedUserWrapper } from '@utils/authenticatedUserWrapper';

import { CHICOREE_VIP_BENEFITS_PARTIAL_NAME } from '@common/constants/cms';
import * as endpoints from '@common/endpoints';

const PreRegisterPage = ({ pageData }) => <PreRegister pageData={pageData} />;

export const getServerSideProps = wrapper.getServerSideProps(
  authenticatedUserWrapper(async (store, { locale }) => {
    let pageData = null;

    try {
      const { data } = await request.get(
        endpoints.cmsPartial(CHICOREE_VIP_BENEFITS_PARTIAL_NAME),
      );

      pageData = data;
    } catch (e) {
      pageData = null;
    }

    return {
      props: {
        ...(await serverSideTranslations(locale)),
        pageData,
      },
    };
  }),
);

PreRegisterPage.propTypes = {
  pageData: PropTypes.shape({
    body: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default PreRegisterPage;
